import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Group extends Model {
    static entity = 'groups';

    static modelName = 'Group';

    static fields() {
        return {
            id: this.attr(null),
            external_id: this.attr(null),
            name: this.attr(null),
            has_terms: this.attr(null),
            category_id: this.attr(null),
            users_count: this.attr(null),
            course_ids: this.attr(null),

            ...super.fields(),

            users: this.hasMany('user_groups', 'group_id'),
            courses: this.hasMany('course_group', 'group_id'),
            category: this.belongsTo('group_categories', 'category_id'),
            term_schedules: this.hasMany('term_schedules', 'group_id'),
        };
    }

    static searchable() {
        return ['name', 'category.name'];
    }

    get modelName() {
        return 'Group';
    }

    get router_link() {
        return {
            name: 'group-view',
            params: { groupId: this.id },
        };
    }

    static queryBuilder(id = null) {
        const param = id ? `/${id}` : '';

        return new QueryBuilder(this.entity + param);
    }

    static async fetch() {
        const { response } = await this.api().get(this.queryBuilder().toUrl());

        return response.data;
    }
}
